var _defs, _polygon, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEau = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 84.32 85.41",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#081221",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "27.67 69.24 27.67 69.24 27.48 69.06 26.88 68.44 15.8 57.17 13.5 46.48 18.71 29.93 24.66 23.19 48.95 12.07 64.29 19.37 70.82 44.7 69.57 53.21 60.6 68.01 50.91 73.34 35.05 73.02 35.05 73.02 34.03 72.99 33.86 72.97 27.67 69.24",
    fill: "#45a084",
    filter: "url(#drop-shadow-5)",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.56,22.14l-24.29,11.12-5.21,16.55,10.54,11.84.19.18.08.12.17.02h.23s15.85.31,15.85.31l8.97-14.8-6.53-25.33ZM49.9,60.03l-14.01-.28-9.33-10.47,4.54-14.41,18.45-8.45-6.58,8.27,5.59,6.04-8.71,6.91,1.38,1.74,10.59-8.39-5.92-6.4,6.49-8.16,5.34,20.71-7.82,12.91Z",
    fill: "#252544",
    strokeWidth: 0
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEau);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Eau.7fdd81fb31e75b5968d9e4e1d58544b1.svg";